import { QueryType } from '@component/ListTable'
import CommonService from '@service/commonService'
import '@src/assets/style/main.scss'
import { goto } from '@src/route'
import { Modal } from 'antd-mobile-v2'
import React from 'react'
import GuaranteeApplication from '../guarantee-application'
import FinancePlan from '../finance-plan'
import LeaseContract from '../lease-contract'
import LoanApplication from '../loan-application'

type LoanCenterStateType = {
  tabKey: number
  style?: any
}

export default class LoanCenter extends React.Component<
  any,
  LoanCenterStateType
> {
  resizeListener?: any

  constructor(props: any) {
    super(props)
    this.state = {
      tabKey: props.activeSecondKey || 1,
    }
  }

  componentDidMount() {
    const height = window.innerHeight
    this.setState({
      style: { height: `${height}px` },
    })

    this.resizeListener = () => {
      const height = window.innerHeight
      this.setState({
        style: { height: `${height}px` },
      })
    }
    window.addEventListener('resize', this.resizeListener)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener)
  }

  logout() {
    Modal.alert('确认退出登录?', '', [
      { text: '取消' },
      {
        text: '退出',
        onPress: () => {
          CommonService.logout().finally(() => {
            goto('/login')
          })
        },
      },
    ])
  }

  commonAction(params: any) {
    const queryParam = {
      ...params,
      rows: 10,
    }
    return CommonService.getCenterList(queryParam).then((rs) => {
      return {
        list: rs.rows,
        total: rs.total || 0,
      }
    })
  }

  getApply(param: QueryType) {
    //
    const queryParam = {
      ...param,
      size: 10,
    }
    return CommonService.applyList(queryParam).then((rs) => {
      return {
        list: rs.rows,
        total: rs.total || 0,
      }
    })
  }

  getQualification(param: QueryType) {
    //待评估-0、已通过-1、已拒绝-9
    const queryParam = {
      ...param,
      size: 10,
    }
    return CommonService.qualificationList(queryParam).then((rs) => {
      return {
        list: rs.rows,
        total: 0,
      }
    })
  }

  onTabClick(mod: number) {
    this.setState({ tabKey: mod })
    this.props.changeKey(mod)
  }

  render() {
    const { tabKey } = this.state
    return (
      <div className="main-page">
        {/* head */}
        <div className="main-head">
          <div className="main-head-tab-bar">
            <div
              className={tabKey == 0 ? 'bar-item active' : 'bar-item'}
              onClick={() => this.onTabClick(0)}
            >
              担保申请
            </div>
            <div
              className={tabKey == 1 ? 'bar-item active' : 'bar-item'}
              onClick={() => this.onTabClick(1)}
            >
              金融方案
            </div>
            <div
              className={tabKey == 2 ? 'bar-item active' : 'bar-item'}
              onClick={() => this.onTabClick(2)}
            >
              相关合同
            </div>
            <div
              className={tabKey == 3 ? 'bar-item active' : 'bar-item'}
              onClick={() => this.onTabClick(3)}
            >
              放款申请
            </div>
          </div>
        </div>
        {/* body */}
        <div className="main-body">
          {/* 担保申请 */}
          <GuaranteeApplication
            action={this.commonAction.bind(this)}
            hide={tabKey !== 0}
          />
          {/* 金融方案 */}
          <FinancePlan
            action={this.commonAction.bind(this)}
            hide={tabKey !== 1}
          />
          {/* 相关合同 */}
          <LeaseContract
            action={this.commonAction.bind(this)}
            hide={tabKey !== 2}
          />
          {/* 放款申请 */}
          <LoanApplication
            action={this.commonAction.bind(this)}
            hide={tabKey !== 3}
          />
        </div>
      </div>
    )
  }
}
